module.exports = __webpack_public_path__ + "static/media/gain_strip.95d28097.png";